import { render, staticRenderFns } from "./CreateAutoActionVerticalStep4.vue?vue&type=template&id=2aa89b64&"
import script from "./CreateAutoActionVerticalStep4.vue?vue&type=script&lang=ts&"
export * from "./CreateAutoActionVerticalStep4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports